export function isColumnSorted(
  sortKey: string,
  activeSortColumn: string,
  activeSortOrder: string,
): boolean {
  return !!sortKey && sortKey === activeSortColumn && !!activeSortOrder;
}
